import { render, staticRenderFns } from "./HistoricoEscolar.vue?vue&type=template&id=4bc5fe7e&scoped=true&"
import script from "./HistoricoEscolar.vue?vue&type=script&lang=js&"
export * from "./HistoricoEscolar.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoEscolar.vue?vue&type=style&index=0&id=4bc5fe7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5fe7e",
  null
  
)

export default component.exports